import { useState } from "react";
// Components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderPp } from "../../../components/Landing/Header/haederPp";
import { Footer } from "../../../components/Landing/Footer";
import "antd/dist/antd.css"
import '../PeopleList.scss';
import headerPP from "../../../assets/pp/Header-PP.jpg"
import banner from "../../../assets/pp/ampliacion.jpeg"
import fomento from "../../../assets/pp/Banner-Estimulos.png"
const formacion = process.env.PUBLIC_URL + encodeURI("/assets/pp/formacion.png");
const fortalecimiento = process.env.PUBLIC_URL + encodeURI("/assets/pp/fortalecimiento.png");
const agenda = process.env.PUBLIC_URL + encodeURI("/assets/pp/agendaCultural.png");
const cartillaPdf = process.env.PUBLIC_URL + encodeURI("/assets/Cartilla Sigamos PES_.pdf");
// style
import "../landing.style.scss";
import { CarouselCustom } from "../components/Carousel/CarouselCustom";

export const Pp = () => {

  const imageUrls = [
    'https://drive.google.com/file/d/1BX-2-8mPpHpQ8DWe70-SjKatCyPZwSf1/preview',
    'https://drive.google.com/file/d/15vAk2Rf81UpQaRaoCSOV86q1ZnI_3xhu/preview',
    'https://drive.google.com/file/d/1jDAsCWbNMfiC5rQKysl2933YS-A6ivbK/preview',
    'https://drive.google.com/file/d/1o66bW9DrUnwZf9jwmW3n3FrKkHaci-Mw/preview',
    'https://drive.google.com/file/d/1juQiTqolSKcCoG8CU75dsAhPdcjtGIdr/preview',
    'https://drive.google.com/file/d/1pUxhyvsBu3lfePeKkMe32sJFsZHJTqf4/preview',
    'https://drive.google.com/file/d/1nRCrRBgmuLkTVRLzIOz4PfiMDz70jo5E/preview',
    'https://drive.google.com/file/d/1jIiHZfgT6WyXoAFAVP-t94q4nxJAK1Mc/preview',
    'https://drive.google.com/file/d/1m4bNyo6tx27Qst5R10wQ36Ab_6wgO5j5/preview',
    'https://drive.google.com/file/d/1z4Iu0JKGkIW0j5kNEgZ3mewo135-888H/preview',
    'https://drive.google.com/file/d/1aUdHVtsEx7cJREUhC_pDoWZZ0zEvBvAh/preview',
    'https://drive.google.com/file/d/13gMx4VeQb18BukxeDkjOjnh646BFE7DW/preview',
    'https://drive.google.com/file/d/1BpAew6QsVBjTRHqD5gRnoJ9VvOf1Gxea/preview',
    'https://drive.google.com/file/d/1F6ydsuMqzTcFh1HV_dktxpAdyqpOHipv/preview',
    'https://drive.google.com/file/d/1ULflyFQUGKXZ6dzmJVd0RPT2PS1XGJ3e/preview',
    'https://drive.google.com/file/d/1WEuww0-k2vOvtnaYfmJpzyAge72ZxfOl/preview',
    'https://drive.google.com/file/d/17gJMo6okofMf0AyyW_IqY38hkjpTtisr/preview',
    'https://drive.google.com/file/d/11Jjyk0HiTdtRMwnN-MycMvpi0iLp2H0E/preview',
    'https://drive.google.com/file/d/1NteODSTHXa47_nR0vvQ-ABmT9P3PWQG8/preview',
    'https://drive.google.com/file/d/1cf4Rt746sk77H05vT-limKysnKfVSj22/preview',
    'https://drive.google.com/file/d/1VidCKfav0dTulV3KW7-0ZAz1a86jiIup/preview',
    'https://drive.google.com/file/d/1igRJVS_z5YWNBVl7_Tx1lFCs1CMe1x83/preview',
    'https://drive.google.com/file/d/1F1tpzRVICY9fbBwQalt-pfL-Ek5FGFgX/preview'
  ];

  const [failedImages, setFailedImages] = useState<Set<number>>(new Set());
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const handleImageError = (index: number) => {
    setFailedImages((prev) => new Set(prev).add(index));
  };

  const openModal = (index: number) => setSelectedIndex(index);
  const closeModal = () => setSelectedIndex(null);

  const next = () => {
    if (selectedIndex !== null) {
      setSelectedIndex((selectedIndex + 1) % imageUrls.length);
    }
  };

  const prev = () => {
    if (selectedIndex !== null) {
      setSelectedIndex((selectedIndex - 1 + imageUrls.length) % imageUrls.length);
    }
  };

  return (
    <div>
      <Header />
      <HeaderPp />
      <img src={headerPP} alt="Convocatorias arte y cultura PP" style={{ width: "100%", height: "auto", objectFit: "cover" }} />
      <CarouselCustom
        images={[
          { src: banner, alt: "Ampliación de la convocatoria PP cultura 2026" },
        ]}
      />
      <div className="container-fluid2 pt-5 pb-4" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h2 style={{ fontWeight: 'bold', color: '#000', marginBottom: '15px', textAlign: 'center' }}>
          Cartilla pedagógica del Plan Especial de Salvaguardia (PES) de la Manifestación Cultural Silletera.
        </h2>
        <p style={{ fontSize: '16px', color: '#444', textAlign: 'justify', marginBottom: '30px', padding: '0 15px' }}>
          Esta cartilla pedagógica facilita la comprensión y apropiación del Plan Especial de Salvaguardia (PES) de la Manifestación Cultural Silletera de Santa Elena. A través de contenidos gráficos y pedagógicos, presenta conceptos sobre patrimonio, salvaguardia y cultura silletera, y destaca la importancia de proteger, valorar y transmitir los saberes, prácticas y tradiciones que hacen parte de esta manifestación cultural.
        </p>
        <iframe
          src={cartillaPdf}
          width="100%"
          height="800"
          style={{ border: 'none', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
          title="Documento PDF PP"
        />
      </div>
      <div className="container-fluid2 pt-5">
        <div className="row justify-content-center cards-container2">
          <div className="col-md-3 col-sm-12 cards-container2">
            <a href="ppestimulos" className="card3-link">
              <div className="card3">
                <img
                  src={fomento}
                  alt="Fomento y Estímulos"
                  className="image3"
                />
                <div className="label3">
                  <span>Fomento <br /> y Estímulos</span>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-3 col-sm-12 cards-container2">
            <a href="ppformacion" className="card3-link">
              <div className="card3">
                <img
                  src={formacion}
                  alt="Formación Artística"
                  className="image3"
                />
                <div className="label3">
                  <span>Formación <br /> Artística</span>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-3 col-sm-12 cards-container2">
            <a href="ppfortalecimiento" className="card3-link">
              <div className="card3">
                <img
                  src={fortalecimiento}
                  alt="Fortalecimiento al Sector Cultural"
                  className="image3"
                />
                <div className="label3">
                  <span>Fortalecimiento <br /> al Sector Cultural</span>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-3 col-sm-12 cards-container2">
            <a href="ppagenda" className="card3-link">
              <div className="card3">
                <img
                  src={agenda}
                  alt="Agenda Cultural"
                  className="image3"
                />
                <div className="label3">
                  <span>Agenda <br /> Cultural</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="container-fluid2 pt-5" style={{ marginTop: '0' }}>
        <div className="font-family-Montserrat text-center font-color-black" style={{ fontSize: 60 }}>
          <strong>
            <h1 style={{ color: '#1e3a53' }}>
              GALERÍA
            </h1>
          </strong>
          <h4 className="mb-3" style={{ textAlign: 'center', marginTop: '10px' }}>
            Revive los momentos más especiales de nuestras actividades, encuentros y jornadas de participación.
          </h4>
        </div>
      </div>
      <div className="gallery-container">
        <div className="gallery-grid">
          {imageUrls.map((link, i) =>
            failedImages.has(i) ? (
              <div key={link} className="iframe-wrapper">
                <iframe
                  src={link}
                  title={`iframe-${i}`}
                  width="100%"
                  height="200"
                  className="gallery-iframe"
                />
                <button type="button" className="iframe-overlay" onClick={() => openModal(i)} />
              </div>
            ) : (
              <button type="button" key={link || String(i)} onClick={() => openModal(i)} style={{background:'none',border:'none',padding:0,cursor:'pointer'}}>
                <img
                  src={link}
                  alt={`imagen-${i}`}
                  onError={() => handleImageError(i)}
                />
              </button>
            )
          )}
        </div>
        {selectedIndex !== null && (
          <button type="button" className="gallery-modal" onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}>
            <div className="gallery-modal-content">
              <button onClick={prev}>&larr;</button>
              {failedImages.has(selectedIndex) ? (
                <iframe
                  src={imageUrls[selectedIndex]}
                  width="100%"
                  height="100%"
                  title={`iframe-modal-${selectedIndex}`}
                />
              ) : (
                <img src={imageUrls[selectedIndex]} alt="modal-img" />
              )}
              <button onClick={next}>&rarr;</button>
              <button type="button" className="close-button" onClick={closeModal}>×</button>
            </div>
          </button>
        )}
      </div>
      <br />
      <Footer />
    </div>
  );
};
